import { useTranslation } from "react-i18next";
import TranslationField from "../../../type/translationField";
import { defaultLang, secondLang } from "../../../utils";

const ScientificNamesTooptip: React.FC<{ names: TranslationField[] }> = ({
  names,
}) => {
  const { i18n } = useTranslation();
  return (
    <div className="name-number">
      <span className=" text-white text-[12px]">+ {names.length - 1}</span>
      <div className="name-content shadow-2xl">
        {names.map((name, index) => (
          <h3 className="p-2" key={index}>
            {i18n.language === secondLang
              ? name[secondLang] || name[defaultLang]
              : name[defaultLang]}
          </h3>
        ))}
      </div>
    </div>
  );
};

export default ScientificNamesTooptip;
